// @todo проверить, нужен ли этот eslint-disable
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import { Panel, Text, Button } from "@vkontakte/vkui";
import styles from "./SelectedEqueuePanel.style";
import PanelHeader from "@vkontakte/vkui/dist/components/PanelHeader/PanelHeader";
import { connect } from "react-redux";
import { setPreviousPanel } from "../../redux/actions/panelsActions";
import StatusLine from "../EqueuesPanel/StatusLine/StatusLine";
import ScreenSpinner from "@vkontakte/vkui/dist/components/ScreenSpinner/ScreenSpinner";
import Div from "@vkontakte/vkui/dist/components/Div/Div";
import { cancelEqueueStart } from "../../redux/actions/equeuesActions";
import { selectEqueueLoadingStart } from "../../redux/actions/selectedEqueueAction";

import { setActiveAlert } from "../../redux/actions/alertsActions";
import ConfirmCancelEqueueAlert from "../../alerts/ConfirmCancelEqueueAlert";
import { parseISO, format, isBefore } from "date-fns";
import { ru } from "date-fns/locale";
import Icon28ArrowLeftOutline from "@vkontakte/icons/dist/28/arrow_left_outline";
import { hideEqueuesSnackBar } from "../../redux/actions/snackbarsActions";
import {setMetrics} from "../../helpers/metrics";

const SelectedEqueuePanel = ({
  id,
  selectedEqueueId,
  selectedEqueue,
  goBack,
  cancelEqueue,
  showMainLoader,
  showCancelLoader,
  startLoadingEqueue,
  showConfirmCancelEqueue,
  userInfo,
  hideSnackBar,
}) => {
  useEffect(() => {
    hideSnackBar();
    startLoadingEqueue(selectedEqueueId);
  }, []);

  const getFullDateTime = (date) => {
    if (isYearShown(selectedEqueue)) {
      return format(parseISO(date), "dd MMMM (EEEE) y, HH:mm", { locale: ru });
    } else {
      return format(parseISO(date), "dd MMMM (EEEE), HH:mm", { locale: ru });
    }
  };

  const isYearShown = (equeue) => {
    if (equeue) {
      const createdDate = new Date(equeue.detail.eventAttributes[1].value);
      const createdYear = createdDate.getFullYear();
      const currentYear = new Date().getFullYear();
      return createdYear !== currentYear;
    } else {
      return false;
    }
  };

  const getValueByName = (name) => {
    const value = selectedEqueue.detail.eventAttributes.filter(
      (value) => value.name === name
    )[0];
    return value ? value.value : "";
  };

  const onCancelButtonClick = () => {
    showConfirmCancelEqueue();
  };

  const showCancelButton = (selectedEqueue) => {
    const currentDate = new Date();
    const pointDate = parseISO(selectedEqueue.detail.event.date);

    return isBefore(currentDate, pointDate);
  };

  useEffect(() => setMetrics('reachGoal','OldHealth.BookingDetails'), []);

  return (
    <Panel id={id}>
      <PanelHeader
        separator={false}
        left={
          <Div
            style={{
              padding: "0",
              display: "flex",
              justifyContent: "left",
            }}
          >
            <Icon28ArrowLeftOutline
              onClick={() => {
                if (!showCancelLoader) {
                  goBack();
                }
              }}
              fill={"#06844D"}
            />
            <Text style={styles.headerText}>Запись к врачу</Text>
          </Div>
        }
      ></PanelHeader>
      <Div style={styles.container}>
        {!showMainLoader && selectedEqueue ? (
          <>
            {selectedEqueue.status === "rejected" ||
            selectedEqueue.status === "reject" ? (
              <StatusLine status="rejected" title="Запись отменена заявителем" center />
            ) : null}
            <Text weight="regular" style={styles.secondHeader}>
              Время приема
            </Text>
            <Text weight="regular" style={styles.primaryText}>
              {getFullDateTime(selectedEqueue.detail.localEventDate)}
            </Text>
            <Text weight="regular" style={styles.secondHeader}>
              Врач
            </Text>
            <Text
              weight="regular"
              style={{ ...styles.primaryText, ...styles.firstUpperCase }}
            >
              {getValueByName("doctor")}
            </Text>
            <Text weight="regular" style={styles.primaryText}>
              {getValueByName("doctorname")}
            </Text>
            <Text weight="regular" style={styles.secondHeader}>
              Место
            </Text>
            <Text weight="regular" style={styles.primaryText}>
              {getValueByName("nameStateOrganization")}
            </Text>
            <Text
              weight="regular"
              style={{
                ...styles.primaryText,
                ...styles.green,
                marginTop: "3vh",
              }}
            >
              {getValueByName("address")}
            </Text>
            <Text weight="regular" style={styles.secondHeader}>
              Пациент
            </Text>
            <Text weight="regular" style={styles.primaryText}>
              {userInfo.formattedName}
            </Text>
            {selectedEqueue.status === "done" ? (
              <>
                {showCancelLoader ? (
                  <Div style={styles.cancelSpinner}>
                    <ScreenSpinner />
                  </Div>
                ) : showCancelButton(selectedEqueue) ? (
                  <Button
                    size="xl"
                    mode="overlay_outline"
                    onClick={onCancelButtonClick}
                    align="center"
                    style={{
                      ...styles.cancelButton,
                      ...styles.green,
                    }}
                  >
                    Отменить запись
                  </Button>
                ) : null}
              </>
            ) : null}
          </>
        ) : (
          <Div style={styles.spinner}>
            <ScreenSpinner />
          </Div>
        )}
      </Div>
    </Panel>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedEqueue: state.selectedEqueue.selectedEqueue,
    showMainLoader: state.loader.showSelectedEqueueLoader,
    showCancelLoader: state.loader.showCancelEqueueLoader,
    selectedEqueueId: state.selectedEqueue.selectedEqueueId,
    userInfo: state.userInfo.userInfo,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    goBack: () => {
      dispatch(setPreviousPanel());
    },
    cancelEqueue: (extId, eserviceId) =>
      dispatch(cancelEqueueStart(extId, eserviceId)),
    startLoadingEqueue: (id) => dispatch(selectEqueueLoadingStart(id)),
    showConfirmCancelEqueue: () =>
      dispatch(setActiveAlert(<ConfirmCancelEqueueAlert />)),
    hideSnackBar: () => dispatch(hideEqueuesSnackBar()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectedEqueuePanel);
